<template>
  <div class="container">
    <hr class="space space-sm">
    <loader v-if="isLoading"></loader>
    <div v-else>
      <div class="row align-items-center" v-if="!isLoading">
        <div class="col-md-6">
          <h1 v-if="subject">{{ subject.title }}</h1>
          <p>{{ subject.description }}</p>
          <p>
            <a href="#" @click.prevent="openPaymentModal()" class="btn btn-lg btn-success">
              <span v-if="subject.isFree">Записаться</span>
              <span v-else>Купить за 9 990 ₽</span>
            </a>
          </p>
        </div>
        <div class="col-md-5 offset-md-1">
          <img src="/static/images/subjects/subject.png" alt="" class="img-fluid">
        </div>
      </div>
      <hr class="space space-sm">
    </div>

    <subject-payment :subject="subject" ref="modal" @update="update"></subject-payment>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubjectPayment from './Includes/SubjectPaymentModal'

export default {
  name: 'subject',
  props: ['id'],
  components: {
    subjectPayment: SubjectPayment
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      subject: state => state.managers.subject,
      variants: state => state.managers.variants,
      isLoading: state => state.auth.loading
    })
  },
  methods: {
    openPaymentModal () {
      this.$refs.modal.toggleModal()
    },
    update () {
      this.$refs.modal.hideModal()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
    this.$store.dispatch('GET_SUBJECT', this.id).then(() => {
      this.$store.dispatch('SET_LOADING', false)
    })
    this.$store.dispatch('GET_SUBJECT_VARIANTS', this.id)
  }
}
</script>